<div *ngIf="isLoading" class="mt-10">
  <ngx-skeleton-loader [theme]="{ height: '120px', width: '100%' }"></ngx-skeleton-loader>
</div>

<div *ngIf="!isLoading">
  <div *ngIf="!isContractApproved && !isContractSignature && !isContractRejected && !isContractTerminated && !isContractRecalled" class="info-banner">
    Please complete all previous steps before sending contract for signature.
  </div>
  <div *ngIf="isContractRejected && !isContractApproved && !isContractRecalled" class="info-banner">
    Kindly make the required changes before sending the contract again for signatures.
  </div>
  <!-- Termination Reason Section -->
  <div *ngIf="isContractTerminated" class="info-banner">
    <h5 class="mb-2">Termination Reason:</h5>
    <p class="termination-reason-text">{{terminationReason || 'No termination reason provided'}}</p>
  </div>
  <!-- Recall Reason Section -->
  <div *ngIf="isContractRecalled" class="info-banner">
   <b>Recall Reason:</b> {{recallReason || 'Contract has been recalled.'}}
  </div>
  <div class="row" *ngIf="isContractApproved || isContractSignature || isContractRejected || isContractTerminated || isContractRecalled">
    <div class="col-md-9">
      <!-- PDF viewer for approved/pending/signed contracts -->
      <ngx-extended-pdf-viewer *ngIf="!isContractRejected && !isContractTerminated && !isContractRecalled" id="pdf-viewer" class="pdf-container" cdkDropList
        (cdkDropListDropped)="onPdfDrop($event)" [src]="actualPdfUrl" [showDrawEditor]="false" [showPrintButton]="false"
        [showOpenFileButton]="false" [showSecondaryToolbarButton]="false" [showSidebarButton]="false"
        [showStampEditor]="false" [pageViewMode]="'infinite-scroll'" [showTextEditor]="false" [sidebarVisible]="false"
        [showZoomButtons]="false" [showRotateButton]="false" [showPagingButtons]="false"></ngx-extended-pdf-viewer>
      <div #container *ngIf="!isContractSignature && !isContractRejected && !isContractTerminated"></div>
      <!-- Message for terminated / recalled contracts -->
      <div *ngIf="isContractTerminated" class="terminated-message">
        <p>This contract has been terminated.</p>
      </div>
      <div *ngIf="isContractRecalled" class="terminated-message">
        <p>This contract has been recalled.</p>
      </div>
    </div>
    <!-- Signatory list for approved or rejected contracts -->
    <div class="col-md-3 signers" cdkDropList id="signers-drop-list" #signersDropList="cdkDropList"
      [cdkDropListData]="signatures.Signatories" [cdkDropListConnectedTo]="['pdf-viewer']" (cdkDropListDropped)="onDrop($event)"
      *ngIf="isContractApproved || isContractRejected" [ngClass]="{'fixed-sidebar': isSidebarFixed, 'top-gap': isSidebarFixed}">
      <h4>Configure Signers 
        <button mat-button class=" add-signer-btn" [disabled]="!isContractApproved && !isContractRejected" (click)="openAddSignatory()">
          <span class="button-content">
            <ng-icon name="heroUserPlus"></ng-icon>
            <span>Add New</span>
          </span>
        </button>
      </h4>
      <!-- <div class="signature-guide"> -->
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="guide-heading">Signature Navigation steps</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ol class="steps-list">
              <li *ngFor="let step of signatureGuideSteps; let i = index">
                <strong>{{step.title}}:</strong> {{step.description}}
              </li>
            </ol>
          </mat-expansion-panel>
        </mat-accordion>
      <!-- </div> -->
      <div *ngFor="let signatory of signatures.Signatories; let i = index" class="signer">
        <span class="signatory-type">
          {{signatory.isAdditional ? 'e' : 'i'}}
        </span>
        <div class="d-flex justify-content-between align-items-center w-100">
            <div class="d-flex align-items-center flex-grow-1" 
                 [cdkDrag]="!isContractRejected" 
                 [cdkDragData]="{index: i}" 
                 (cdkDragStarted)="onDragStart()"
                 (cdkDragEnded)="onDragEnd()">
            <div class="signatory-info">
              <label>{{signatory.Name}} <small>{{signatory.EmailId}}</small></label>
              <div class="signatory-status-badge" *ngIf="signatory.Status && !isContractApproved">
                <span [ngClass]="getStatusClass(signatory.Status)" class="status-badge">
                  {{ signatory.Status }}
                </span>
                <span *ngIf="signatory.Status === 'Rejected' && signatory.RejectionReason" class="rejection-reason-text">
                  : {{ signatory.RejectionReason }}
                </span>
              </div>
            </div>
          </div>
          <div class="signer-actions" *ngIf="!dragging">
            <button mat-icon-button (click)="editSignatory(i)" [disabled]="!isContractApproved && !isContractRejected">
              <ng-icon name="heroPencil"></ng-icon>
            </button>
            <button mat-icon-button (click)="deleteSignatory(i)" [disabled]="!isContractApproved && !isContractRejected">
              <ng-icon name="heroTrash"></ng-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="p-2 my-2">
        <div class="mb-2" *ngIf="isContractApproved">
          <mat-slide-toggle [(ngModel)]="useDocuSign" [disabled]="!isContractApproved || isLoading" 
            [class.docusign-active]="useDocuSign" color="primary">
            <span>Use DocuSign</span>
          </mat-slide-toggle>
        </div>
        <div class="d-flex justify-content-end" *ngIf="isContractApproved">
          <button mat-raised-button color="accent"
            [disabled]="isLoading || !signatures?.Signatories?.length" (click)="sendForSign()"
            class="send-signature-btn">
            {{ useDocuSign ? 'Send via DocuSign' : 'Send' }}
            <mat-icon matSuffix *ngIf="isLoading">
              <mat-spinner diameter="18"></mat-spinner>
            </mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-3 signers" *ngIf="isContractSignature || isContractTerminated" [ngClass]="{'fixed-sidebar': isSidebarFixed}">
      <h4>Signing Details</h4>
      <ng-container *ngIf="signingDetails">
        <div *ngFor="let signatory of signingDetails.Signatories; let i = index"
          [ngClass]="getStatusClass(signatory.Status)" class="m-3 px-3 rounded">
          <div class="d-flex justify-content-between align-items-center p-0 ">
            <div>
              <div class="d-flex justify-content-between align-items-center">
                <div class="flex-grow-1">
                  <label class="mb-0">{{signatory.Name}}</label><br>
                  <label>{{signatory.EmailID}}</label>
                </div>
              </div>
              <label><small>{{signatory.Remarks}} </small> <small *ngIf="signatory.SignedDate">{{signatory.SignedDate |
                  date:'dd-MM-yyyy HH:mm:ss'}}</small></label>
            </div>
            <div>
              <label class="status-label text-center">{{signatory.Status}}</label>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

</div>